import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=c4d06d04"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js"
import style0 from "./RegisterConfirm.vue?vue&type=style&index=0&id=c4d06d04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports